export { getStoresServerAction } from 'next-flight-server-reference-proxy-loader?id=70429dd383de60892f5a51e8cc61d5949e3f868e7f&name=getStoresServerAction!'